
export const changeLanguage = (languageKey) => (dispatch) => {
  dispatch({type: languageKey})
}